import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import stylesCoup from '../Shared/Css/GesansuList/GesansuList.module.css';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

function ProductivityLoading() {
  const classes = useStyles();
  return (
    <>
      <div className={`stylesCoup.container`}>
        <div className={classes.root} >
          <h4 className={stylesCoup.child01} >실행중이니 잠시만기다리세요..</h4>
          <CircularProgress className={stylesCoup.child02} color="secondary" />
        </div>
      </div>
    </>
  )
}

export default ProductivityLoading